import { render, staticRenderFns } from "./audioBox.vue?vue&type=template&id=8abecf82"
import script from "./audioBox.vue?vue&type=script&lang=js"
export * from "./audioBox.vue?vue&type=script&lang=js"
import style0 from "./audioBox.vue?vue&type=style&index=0&id=8abecf82&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports